import type { IResponse } from '../interface/common'
import { fetch } from '../request'
import type {
  AddCollectionRequest,
  CollectionListRequest,
  CollectionList,
  CopyToTeamRequest,
  CancelCollectRequest,
} from '../interface/collection'

// 获取收藏列表
export const getCollectionList = (params: CollectionListRequest) => {
  return fetch<IResponse<CollectionList>>('/youyan/personal_star/', {
    method: 'GET',
    params,
  })
}

// 添加收藏
export const addCollect = (params: AddCollectionRequest) => {
  return fetch<IResponse>('/youyan/personal_star/star/', {
    method: 'POST',
    body: params,
  })
}

// 取消收藏
export const cancelCollect = (params: CancelCollectRequest) => {
  return fetch<IResponse>('/youyan/personal_star/cancel_star/', {
    method: 'POST',
    body: params,
  })
}

// 复制到团队空间
export const copyToTeam = (data: CopyToTeamRequest) => {
  return fetch<IResponse>('/youyan/team_space/copy_to_team/', {
    method: 'POST',
    body: data,
  })
}

// 成片另存新作品编辑
export const createTaskEdit = (data: { id: number }) => {
  return fetch<IResponse>('/youyan/personal_star/edit_task/', {
    method: 'POST',
    body: data,
  })
}

// 创建成片模板
export const createTaskTemplate = (data: { id: number }) => {
  return fetch<IResponse>('/youyan/personal_star/create_task_template/', {
    method: 'POST',
    body: data,
  })
}

// 批量下载视频
export const downloadVideos = (data: { personal_star_ids: number[] }) => {
  return fetch<IResponse>('/youyan/personal_star/download_videos/', {
    method: 'POST',
    body: data,
  })
}

export const getSourceIsDeleteIds = (params: { model_type: number }) => {
  return fetch('/youyan/personal_star/get_source_is_delete_ids/', {
    method: 'GET',
    params,
  })
}

// 批量删除失效文件
export const postRemoveSourceIsDelete = (params: { model_type: number }) => {
  return fetch('/youyan/personal_star/remove_source_is_delete/', {
    method: 'POST',
    params,
  })
}
